module.exports = __webpack_public_path__ + "img/pokeball.d41b8170.webp";